import { useCallback } from 'react';
import { useHistory } from '@shared/core';
import { getSlugFromPathname } from '@apps/guest/packages/layout-engine/common/utils/useGuestSitePageChanged';
import { PagesRefs } from '@apps/guest/packages/layout-engine/layouts/LayoutAloha/LayoutAloha.types';
import { EventPageType } from '@graphql/generated';

export const usePageRefFromUrl = () => {
  const history = useHistory();

  const getPageRefFromUrl = useCallback(
    (pagesRef: PagesRefs[]) => {
      const { pagePath: slugFromPathname, isCustomPagePath } = getSlugFromPathname(history.location.pathname);
      const currentPage = pagesRef.find(
        pageRef => slugFromPathname && pageRef.page.pageSlug.toLowerCase() === slugFromPathname?.toLowerCase() && (!isCustomPagePath || pageRef.page.type === EventPageType.custom),
      );
      return currentPage;
    },
    [history.location],
  );

  return getPageRefFromUrl;
};
